<div class="contents-area">
  <div class="block-row">
    <div>
      <div class="element-column">
        <div class="block-row">
          <div class="column-list" style="width: 269px;">
            <label class="list-input-title">受注コード</label>
            <div class="list-input-content">
              <app-order-code-text-input id="txti_OrderCode" #txti_OrderCode [subid]="'txti_OrderCode'"
                [catalogIDField]="lbl_CatalogId" [forcedEnabledMode]="'true'" [tabindex]="0" [required]="true"
                [autofocus]="true" [(ngModel)]="kymw6000Model.orderCode" (ngModelChange)="eventOrderCode_CHANGEHandler()">
              </app-order-code-text-input>
            </div>
            <label class="list-input-title">配達企画回（翌週）</label>
            <div class="list-input-content">
              <input type="text" class="deliv-catalog" id="lbl_CatalogId" #lbl_CatalogId readonly>
            </div>
            <label class="list-input-title">Ｐコード</label>
            <div class="list-input-content">
              <input type="text" class="pcode" id="txti_PCode" forcedEnabledMode="true" [tabindex]="0" maxlength="8" plessInputTextSub
                [restrict]="'[P0-9]'" [(ngModel)]="kymw6000Model.pCode">
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title">媒体</label>
            <div class="list-input-content">
              <app-versatile-combo-box id="cmb_Medium" #cmb_Medium [subid]="'cmb_Medium'"
                [blank]="true" [autofocus]="false" [dspBothField]="true" [listSource]="kymw6000Model.mediumList"
                valueField="MediumType" labelField="MediumName" forcedEnabledMode="true"
                [required]="false" [tabindex]="0" [width]="280"
                (change)="eventCmbMedium_CHANGEHandler()" [(ngModel)]="kymw6000Model.mediumType">
              </app-versatile-combo-box>
            </div>
            <label class="list-input-title">部門</label>
            <div class="list-input-content">
              <app-class-code-combo-box #cmb_ClassCode id="cmb_ClassCode" [required]="false" [width]="280"
                [forcedEnabledMode]="'true'" [tabindex]="0" [blank]="true" [(ngModel)]="kymw6000Model.classCode">
              </app-class-code-combo-box>
            </div>
            <label class="list-input-title">特集</label>
            <app-versatile-combo-box id="cmb_FeatureCode" [(ngModel)]="kymw6000Model.featureCode"
              [listSource]="kymw6000Model.FeatureList"
              [disabled]="false" [required]="false" [tabindex]="0" [dspBothField]="true" 
              [visible]="true" [blank]="true" [autofocus]="false" forcedEnabledMode="true"
              [width]="280" (change)="eventFeatureCode_CHANGEHandler()">
            </app-versatile-combo-box>
          </div>
        </div>
        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title">マルチ・クロス</label>
            <div class="list-input-content content-label">
              <label><input type="checkbox" id="ckb_MultiOrCross"
                [(ngModel)]="multiOrCrossSelected" forcedEnabledMode="true" [tabindex]="0">マルチ・クロスのみ</label>
            </div>              
          </div>
          <div class="column-list">
            <label class="list-input-title">画像未指定</label>
            <div class="list-input-content content-label">
              <label><input type="checkbox" id="ckb_ImageNoUse" 
                [(ngModel)]="imageNoUseSelected" forcedEnabledMode="true" [tabindex]="0">画像未指定のみ</label>
            </div>              
          </div>
          <div class="column-list">
            <label class="list-input-title">未確認</label>
            <div class="list-input-content content-label">
              <label><input type="checkbox" id="ckb_ImageCheck" 
                [(ngModel)]="imageCheckSelected" forcedEnabledMode="true" [tabindex]="0">未確認のみ</label>
            </div>  
          </div>

        </div>
        <button [tabindex]="0" id="btn_Display" class="btn-secondary" #btn_Display
          (click)="eventDisplay_CLICKHandler()" forcedEnabledMode="true" >表示</button>
      </div>
    </div>
  </div>

</div>
